// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanDeleteFramework } from "./hook";

export type CanDeleteFrameworkProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanDeleteFramework({
  children,
  fallback,
  scope,
}: CanDeleteFrameworkProps) {
  const canDoAction = useCanDeleteFramework(scope);
  return <>{canDoAction ? children : fallback}</>;
}
